import { useStoreItem } from "../itemStore.store";
import {
  stakeholderItemStructure,
  useStakeholderStore
} from "./stakeholders.store";

export const useStakeholder = useStoreItem(
  stakeholderItemStructure,
  useStakeholderStore,
  () => {
    return {};
  }
);
